<template>
  <v-layout @click="showUser = true" class="user">
    <v-avatar size="40" class="ma-2">
      <!-- '/static/img/assets/livechat/profile.png' -->
      <template v-if="value.profile_pic == null">
        <img src="/static/img/assets/livechat/profile.png" />
      </template>
      <img v-else :src="value.profile_pic" @error="onFailLoad" />
    </v-avatar>
    <v-flex class="pa-2">
      <div class="text-truncate">{{ value.first_name }} {{ value.last_name }}</div>
      <div class="caption grey--text">{{ value.app }}</div>
      <!-- <v-chip round color="red" text-color="white" disabled small class="ma-0 mt-2">รอนาน</v-chip>
            <v-chip
              round
              color="success"
              text-color="white"
              disabled
              small
              class="ma-0 mt-2"
      >ลูกค้าใหม่</v-chip>-->
      <v-dialog v-if="value" scrollable v-model="showUser" persistent max-width="1040">
        <v-card v-if="showUser">
          <v-layout>
            <v-flex>
              <template v-if="['facebook', 'line'].includes(value.app)">
                <v-btn @click="goToLivechat" color="info">Go to livechat</v-btn>
              </template>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat small fab @click="showUser = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card-text style="height: 600px">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <ticket-customer-detail :value="value.userid" style="border: 1px solid #eee">
                  <div slot="header">&nbsp;</div>
                </ticket-customer-detail>
              </v-flex>
              <v-flex xs12 sm6>
                <manage-ticket
                  v-model="value"
                  @editTicket="onEditTicket"
                  :loading="loading"
                ></manage-ticket>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import TicketCustomerDetail from '@/components/view/dashboard/TicketCustomerDetail'
import ManageTicket from './ManageTicket.vue'
export default {
  props: ['value', 'funnel'],
  data: function () {
    return {
      showUser: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
    }),
  },
  components: {
    TicketCustomerDetail,
    ManageTicket,
  },
  methods: {
    async onEditTicket(ticket) {
      var response = await this.getTicketById(ticket.id)
      if (response.data && response.data.length > 0) this.$emit('onChangeUser', response.data[0])
      this.showUser = false
    },
    getTicketById(id) {
      var data = {
        id: id,
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTimeFormat: function (date1, date2) {
      if (date1.diff(date2, 'days') > 0) {
        return date1.diff(date2, 'days') + ' วัน'
      } else if (date1.diff(date2, 'hours') > 0) {
        return date1.diff(date2, 'hours') + ' ชม'
      } else if (date1.diff(date2, 'minutes') > 0) {
        return date1.diff(date2, 'minutes') + ' นาที'
      } else if (date1.diff(date2, 'seconds') > 0) {
        return date1.diff(date2, 'seconds') + ' วินาที'
      }
    },
    onFailLoad: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    goToLivechat: function () {
      console.log(this.value.context == 'contactadmin')
      console.log(this.value.context)
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: this.value.userid,
          user: this.value.context == 'contactadmin' ? 'admin' : 'bot',
          app: this.value.app,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/FunnelUser.vue